<template>
  <TableRegular
    :loading="loading"
    :rows="rows"
    :columns="columns"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    :line-numbers="lineNumbers"
    @onFilter="$emit('onFilter', $event)"
    @onPageChange="$emit('onPageChange', $event)"
    @onPerPageChange="$emit('onPerPageChange', $event)"
    @onSortChange="$emit('onSortChange', $event)"
  >
    <template slot="table-row" slot-scope="props">
      <p v-if="props.column.field === 'loanPackage'" class="capitalize">
        {{ props.row.loanPackage | currency }}
      </p>
      <div v-else-if="props.column.field === 'status'" class="whitespace-nowrap">
        <div :class="['status', `is-${getStatus(props.row.status)}`]">
          {{ $t(`status.${getStatus(props.row.status)}`) }}
        </div>
      </div>
      <p v-else-if="props.column.field === 'performanceDate'" class="whitespace-nowrap">
        {{ props.row.performanceDate }}
      </p>
      <p v-else-if="props.column.field === 'action'" class="flex justify-end items-center">
        <router-link
          v-if="props.row.firstName && props.row.phone"
          :to="{ name: 'CustomerDetails', params: { customerId: props.row.id } }"
          class="flex items-center mr-3"
        >
          <EyeIcon class="w-4 h-4" />
        </router-link>
        <router-link
          :to="{ name: 'CustomerUpdate', params: { customerId: props.row.id } }"
          class="flex items-center"
        >
          <CheckSquareIcon class="w-4 h-4" />
        </router-link>
      </p>
    </template>
  </TableRegular>
</template>

<script>
import TableRegular from '@/components/ui/table/TableRegular';
import tableMixin from '@/mixins/tableMixin';
import humps from 'humps';

export default {
  mixins: [tableMixin],
  components: {
    TableRegular,
  },
  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
  },
};
</script>
